import React, { useContext, useEffect, useState } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// import { MoneyOff } from "@material-ui/icons";
import MaterialTable from "material-table";

import ReportContext from "../../../../context/reports/ReportContext";

import ReportDetailsToolbar from "./ReportDetailsToolbar";
import SubDetailsProduct from "./ReportDetailsProduct";
import SubDetailsAngle from "./ReportDetailsAngle";

const useStyles = makeStyles(() => ({
  headerTitle: {
    color: "white",
  },
}));

const ReportDetails = ({ tableIcons, numberFormatter, currencyFormatter }) => {
  const classes = useStyles();

  const {
    reports_loading,
    reports,
    filtered_reports,
    // filterByProfit,
    report_type_aureas,
  } = useContext(ReportContext);

  const [data, setData] = useState([]);
  const [group_by_media_buyer, setGroupByMediaBuyer] = useState(false);
  // const [filter_by_profit, setFilterByProfit] = useState(false);

  const media_buyer_grouped =
    report_type_aureas === "Campaign Analytics" && group_by_media_buyer;

  const dividend = (a, b) => (Number.isFinite(a / b) ? a / b : 0);

  const cellStyle = (column) => {
    return {
      border: "1px solid #c7c7c7",
      paddingLeft: column === "1" ? 30 : 10,
      paddingRight: 10,
    };
  };

  const columns = [
    {
      field: "laptop",
      title: <span className={classes.headerTitle}> Laptop </span>,
      align: "left",
      width: report_type_aureas === "Product Analytics" ? "10%" : "9%",
      hidden: media_buyer_grouped,
      cellStyle: cellStyle(),
    },
    {
      field: "angle",
      title: <span className={classes.headerTitle}> Angle </span>,
      align: "left",
      width: "10%",
      hidden: media_buyer_grouped,
      cellStyle: cellStyle(),
    },
    {
      field: "media_buyer",
      title: <span className={classes.headerTitle}> Media Buyer </span>,
      align: "left",
      width: media_buyer_grouped ? "11%" : "7%",
      cellStyle: cellStyle(),
    },
    {
      field: "ad_account_status",
      title: <span className={classes.headerTitle}> Ad Account Status </span>,
      align: "left",
      width: "7%",
      hidden: media_buyer_grouped,
      cellStyle: cellStyle(),
      render: (rowData) => (
        <span
          style={{
            wordBreak: "break-all",
          }}
        >
          {" "}
          {rowData.ad_account_status}{" "}
        </span>
      ),
    },
    {
      field: "visits",
      title: (
        <span className={classes.headerTitle}> Visits </span>
        // <Tooltip placement="top" title="Visits">
        //   <span className={classes.headerTitle}> Visits </span>{" "}
        // </Tooltip>
      ),
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "8%" : "6%",
      cellStyle: cellStyle(),
      render: (rowData) => numberFormatter.format(rowData.visits),
    },
    {
      field: "clicks",
      title: (
        <span className={classes.headerTitle}> Clicks </span>
        // <Tooltip placement="top" title="Clicks">
        //   <span className={classes.headerTitle}> Clicks </span>{" "}
        // </Tooltip>
      ),
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "8%" : "6%",
      cellStyle: cellStyle(),
      render: (rowData) => numberFormatter.format(rowData.clicks),
    },
    {
      field: "conversions",
      title: (
        <span className={classes.headerTitle}> Conversions </span>
        // <Tooltip placement="top" title="Conversions">
        //   <span className={classes.headerTitle}> Conversions </span>{" "}
        // </Tooltip>
      ),
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "11%" : "5%",
      cellStyle: cellStyle(),
      render: (rowData) => numberFormatter.format(rowData.conversions),
    },
    {
      field: "revenue",
      title: <span className={classes.headerTitle}> Revenue </span>,
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "10%" : "8%",
      cellStyle: cellStyle(),
      render: (rowData) => currencyFormatter.format(rowData.revenue),
    },
    {
      field: "cost",
      title: <span className={classes.headerTitle}> Cost </span>,
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "10%" : "8%",
      cellStyle: cellStyle(),
      render: (rowData) => currencyFormatter.format(rowData.cost),
    },
    {
      field: "profit",
      title: <span className={classes.headerTitle}> Profit </span>,
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "10%" : "8%",
      cellStyle: cellStyle(),
      render: (rowData) => {
        let color = "black";
        if (+rowData.profit < 0) color = "red";
        else if (+rowData.profit > 0) color = "green";

        return (
          <span
            style={{
              color,
            }}
          >
            {" "}
            {currencyFormatter.format(rowData.profit)}{" "}
          </span>
        );
      },
    },
    {
      field: "ROAS",
      title: (
        <span className={classes.headerTitle}> ROAS </span>
        // <Tooltip placement="top" title="ROAS">
        //   <span className={classes.headerTitle}> ROAS </span>{" "}
        // </Tooltip>
      ),
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "7%" : "5%",
      cellStyle: cellStyle(),
    },
    {
      field: "CTR",
      title: <span className={classes.headerTitle}> CTR </span>,
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "7%" : "6%",
      cellStyle: cellStyle(),
      render: (rowData) => `${rowData.CTR}%`,
    },
    {
      field: "CV",
      title: <span className={classes.headerTitle}> CV </span>,
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "7%" : "6%",
      cellStyle: cellStyle(),
      render: (rowData) => `${rowData.CV}%`,
    },
    {
      field: "AP",
      title: <span className={classes.headerTitle}> AP </span>,
      type: "numeric",
      align: "right",
      width: media_buyer_grouped ? "7%" : "6%",
      cellStyle: cellStyle(),
      render: (rowData) => currencyFormatter.format(rowData.AP),
    },
  ];

  useEffect(() => {
    let data;

    if (reports) data = reports;
    if (filtered_reports) data = filtered_reports;

    if (data && report_type_aureas) {
      data.forEach((each) => {
        each.type = report_type_aureas;
      });

      // Group By Media Buyer
      if (report_type_aureas === "Campaign Analytics" && group_by_media_buyer) {
        let groups = {};

        data.forEach((each) => {
          if (!Object.keys(groups).includes(each.media_buyer)) {
            groups[each.media_buyer] = {
              media_buyer: each.media_buyer,
              visits: parseFloat(each.visits),
              clicks: parseFloat(each.clicks),
              conversions: parseFloat(each.conversions),
              revenue: parseFloat(each.revenue),
              cost: parseFloat(each.cost),
              profit: parseFloat(each.profit),
              ROAS: 0.0,
              CTR: 0.0,
              CV: 0.0,
              AP: 0.0,
              angle_details: [each],
            };
          } else {
            groups[each.media_buyer].visits += parseFloat(each.visits);
            groups[each.media_buyer].clicks += parseFloat(each.clicks);
            groups[each.media_buyer].conversions += parseFloat(
              each.conversions
            );
            groups[each.media_buyer].revenue += parseFloat(each.revenue);
            groups[each.media_buyer].cost += parseFloat(each.cost);
            groups[each.media_buyer].profit += parseFloat(each.profit);
            groups[each.media_buyer].angle_details.push(each);
          }
        });

        Object.values(groups).forEach((group) => {
          group.revenue = parseFloat(group.revenue).toFixed(2);
          group.cost = parseFloat(group.cost).toFixed(2);
          group.profit = parseFloat(group.profit).toFixed(2);
          group.ROAS = parseFloat(dividend(group.revenue, group.cost)).toFixed(
            2
          );
          group.CTR = parseFloat(
            dividend(group.clicks, group.visits) * 100
          ).toFixed(2);
          group.CV = parseFloat(
            dividend(group.conversions, group.clicks) * 100
          ).toFixed(2);
          group.AP = parseFloat(
            dividend(group.revenue, group.conversions)
          ).toFixed(2);
        });

        data = Object.values(groups);
      }
    }

    setData(data);
  }, [reports, filtered_reports, report_type_aureas, group_by_media_buyer]);

  // useEffect(() => {
  //   filterByProfit(filter_by_profit);
  // }, [filter_by_profit]);

  return (
    <Grid
      item
      style={{
        marginTop: 20,
      }}
    >
      <MaterialTable
        title={report_type_aureas}
        icons={tableIcons}
        columns={columns}
        data={reports_loading ? [] : data}
        isLoading={reports_loading}
        options={{
          showTitle: true,
          toolbar: true,
          search: true,
          paging: false,
          draggable: false,
          sorting: true,
          padding: "dense",
          tableLayout: "fixed",
          detailPanelType: "multiple",
          headerStyle: {
            backgroundColor: "#2f2c3a",
            border: "1px solid white",
            borderBottom: 0,
            zIndex: "auto",
            paddingLeft: 10,
            paddingRight: 10,
          },
        }}
        detailPanel={
          report_type_aureas === "Product Analytics" ||
          (report_type_aureas === "Campaign Analytics" && group_by_media_buyer)
            ? (rowData) => {
                if (rowData.type === "Product Analytics")
                  return (
                    <SubDetailsProduct
                      data={rowData.product_details}
                      currencyFormatter={currencyFormatter}
                    />
                  );

                if (
                  report_type_aureas === "Campaign Analytics" &&
                  group_by_media_buyer
                )
                  return (
                    <SubDetailsAngle
                      data={rowData.angle_details ? rowData.angle_details : []}
                      numberFormatter={numberFormatter}
                      currencyFormatter={currencyFormatter}
                    />
                  );
              }
            : null

          // (rowData) => (rowData.tableData.showDetailPanel = "")
        }
        onRowClick={
          report_type_aureas === "Product Analytics" ||
          (report_type_aureas === "Campaign Analytics" && group_by_media_buyer)
            ? (event, rowData, togglePanel) => togglePanel()
            : null
        }
        components={{
          Toolbar: (props) => (
            <ReportDetailsToolbar
              props={props}
              groupByMediaBuyer={[group_by_media_buyer, setGroupByMediaBuyer]}
            />
          ),
        }}
        // actions={[
        //   {
        //     icon: () => (
        //       <MoneyOff color={filter_by_profit ? "primary" : "disabled"} />
        //     ),
        //     tooltip: `${filter_by_profit ? "Show" : "Hide"} Non Profit`,
        //     isFreeAction: true,
        //     onClick: () => setFilterByProfit(!filter_by_profit),
        //   },
        // ]}
      />{" "}
    </Grid>
  );
};

export default ReportDetails;
